import $ from "jquery";
import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";

import moment from 'moment/moment';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import init from '../../AccessControl/Check';
import UserBasicInfoContext from "../../../../components/Context/UserBasicInfoContext";

// POP UP
import Popup from '../../../../components/Popup';
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';
import { SUPER_ADMIN_CODE } from "../../ConstRole/ConstRole";

const Offer = () => {
    const pageName = "Voucher Offer View";
    const isAccess = init(pageName);


    const userProfile = useContext(UserBasicInfoContext);

    const [reqParam, setReqParam] = useState({
        page: 1,
    });


    const showDropDown = event => {
        $(".dropdownDotsHorizontal").hide();
        event.currentTarget.nextSibling.style.display = "block";
    }

    document.addEventListener('scroll', function () {
        $(".dropdownDotsHorizontal").hide();
    }, true);

    $('body').on("click", function (e) {
        if (e.target?.parentElement?.className === "" || e.target?.parentElement?.className === null || e.target?.parentElement?.className === undefined) {
            return;
        }

        if (e.target.parentElement.className.toString().includes("dropdownMenuIconHorizontalButton mt-2") === false) {
            $(".dropdownDotsHorizontal").hide();
        }
    });


    const [brandList, setBrandList] = useState([]);
    const [deleteModal, setDeleteModal] = useState({
        isShow: false,
        id: ""
    });
    const [isRefresh, setIsRefresh] = useState(0);

    const [apiData, setApiData] = useState({});

    // Get Voucher Offer
    useEffect(() => {
        PostLoginGetApi("voucher/offer", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setDeleteModal(false);
                    setBrandList(responseData["data"]);
                    return;
                }
                return;
            }

        }).catch((err) => {
            console.log(err);
        });
    }, [isRefresh, reqParam]);


    // Inactive Voucher Offer
    const deleteOffer = (id) => {
        try {
            PostLoginPostApi("voucher/offer/update/status/" + id, "", 1, 0, 3).then((responseJSON) => {
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    var responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);

                    if (responseData["code"] === 200) {
                        setDeleteModal(false);
                        toast.success(responseData["messages"].toString() ?? "Voucher offer status updated successfully.");
                        setIsRefresh((prevCounter) => {
                            return prevCounter + 1;
                        });

                        return;
                    }

                    toast.error(responseData["messages"].toString());
                    return;

                }
            }).catch((error) => {
                toast.error("A problem occur. Please try again.");
                console.log(error);
            });
        }
        catch (exception) {
            toast.error("A problem occur.");
            console.log(exception);
        }
    }


    const showBlockMessage = () => {
        alert("Edit is not allowed when offer is started !");
    }


    const [termsData, setTermsData] = useState("");
    const [isTermsShow, setIsTermsShow] = useState(false);
    const closeModel = () => {
        setIsTermsShow(false);
        setTermsData("");
    }
    const openModel = (terms) => {
        setTermsData(terms);
        setIsTermsShow(true);
    }

    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }


    return (
        <div className="custom-container w-full font-montserrat flex -mt-4">

            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] py-3">
                    <div className="w-1/2 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5">Here’s your voucher offers at a glance</h6>
                    </div>

                    <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">
                        <Link to={"create-offer"} className="custom-btn text-center">Create a Voucher Offer</Link>
                    </div>
                </div>





                {/* DATA TABLE  */}
                <div className="flex flex-col w-full pt-2">
                    <div className='-m-1.5 pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className='border rounded-lg shadow'>
                                <table className='min-w-full divide-y divide-gray-200 custom-table-hover '>
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="px-2 py-3 text-center w-10">#</th>
                                            <th scope="col" className="text-center">Offer Logo</th>
                                            <th scope="col" className="px-6 py-3">Offer Title & Brand</th>
                                            <th scope="col" className="py-3 text-center">Face Value</th>
                                            <th scope="col" className="py-3 text-center">Sell Price</th>
                                            <th scope="col" className="py-3 text-center">Discount</th>
                                            <th scope="col" className="px-2 py-3 text-center">Qty</th>
                                            <th scope="col" className="py-3 text-center">Selling Date</th>
                                            <th scope="col" className="text-center" title="Redeem Days">R. Days</th>
                                            <th scope="col" className="px-2 py-3 w-[210px]">Create Date</th>
                                            <th scope="col" className="px-2 py-3 w-[210px]">Update Date</th>
                                            <th scope="col" className="px-2 py-3 text-center">Is Active ?</th>
                                        </tr>
                                    </thead>

                                    <tbody className='divide-y divide-gray-200'>
                                        {(brandList.length === 0) &&
                                            <tr key="0">
                                                <td colSpan={13} className='px-6 py-1 text-center'>
                                                    <p className='py-4'>No voucher offer available</p>
                                                </td>
                                            </tr>
                                        }

                                        {brandList.map((data, index) => (
                                            <tr key={index}>
                                                <td className='px-4 py-2 border-r-2 text-center font-semibold'>
                                                    {index+1}
                                                </td>
                                                <td className='px-1 py-2 border-r-2'>
                                                    <img src={data.logo} title={data.name} alt={data.name} className='max-h-[32px] max-w-[100px] m-auto'></img>
                                                </td>
                                                <td className='px-6 py-2 border-r-2 text-left'>
                                                    <Link className='text-blue-500 font-semibold' onClick={() => openModel(data)}>
                                                        {data.name}
                                                    </Link>
                                                    <br/>{data.brand_name}
                                                </td>
                                                <td className='py-2 border-r-2 text-center'>{data.amount}</td>
                                                <td className='py-2 border-r-2 text-center'>{data.purchase_price}</td>
                                                <td className='py-3 border-r-2 text-center'>
                                                    {data.commission}
                                                    {(data.commission_type === "percentage") && <strong> %</strong> }
                                                </td>
                                                <td className='px-2 py-3 border-r-2 text-center'>
                                                    {data.count}
                                                    <div style={{fontSize: "10px"}}>{(data.is_custom_code === 1) ? "(Custom)" : "(Auto)"}</div>
                                                </td>
                                                <td className='py-2 border-r-2 text-center'>
                                                    {moment(data.validity_start_date, "YYYY-MM-DD").format("DD-MMM-YYYY")}
                                                    <br/>{moment(data.validity_end_date, "YYYY-MM-DD").format("DD-MMM-YYYY")}
                                                </td>
                                                <td className='py-2 border-r-2 text-center'>
                                                    {(data.redeem_type === 'days') ?
                                                        <>{data.redeem_period}</>
                                                        :
                                                        <>
                                                            {moment(data.redeem_start_date, "YYYY-MM-DD").format("DD-MMM-YYYY")}
                                                            <br/>{moment(data.redeem_end_date, "YYYY-MM-DD").format("DD-MMM-YYYY")}
                                                        </>
                                                    }
                                                </td>

                                                <td className='px-2 py-4 border-r-2'>
                                                    {moment(data.created_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='px-2 py-4 border-r-2'>
                                                    {moment(data.updated_at ?? data.created_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                
                                                <td className='py-1 text-center w-[130px]'>

                                                    {((moment(data.validity_start_date, 'YYYY-MM-DD').valueOf()) >= (moment(new Date(), 'YYYY-MM-DD').valueOf())) ?
                                                        <>
                                                            <button onClick={showDropDown} data-dropdown-toggle="dropdownDotsHorizontal" className="dropdownMenuIconHorizontalButton mt-2">
                                                                <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"></path></svg>
                                                            </button>

                                                            <div className="dropdownDotsHorizontal hidden relative z-50">
                                                                <div className='absolute -ml-20 -mt-2 border border-[1px solid rgb(245, 245, 245)] bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600'>
                                                                    <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownMenuIconHorizontalButton">
                                                                        <li className='border-b-[1px] border-b-slate-100'>
                                                                            <Link to={"edit-offer"} state={{ data: data }} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                                Edit
                                                                            </Link>
                                                                        </li>
                                                                        <li className='border-b-0 border-b-slate-100'>
                                                                            <span onClick={() => setDeleteModal({ isShow: true, id: data.id })} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" >
                                                                                Delete
                                                                            </span>
                                                                        </li>

                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        <>
                                                            <label className="toggle">
                                                                <input className="toggle-checkbox" type="checkbox" defaultChecked={data.is_start} placeholder="is_active" onChange={() => setDeleteModal({ isShow: true, id: data.id })} />
                                                                <div className="toggle-switch"></div>
                                                                <span className="toggle-lab
                                                                el"></span>
                                                            </label>


                                                            {userProfile?.user_type_id === SUPER_ADMIN_CODE && 
                                                                <Link to={"edit-offer"} state={{ data: data }} className="py-1 px-2 justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-xs dark:focus:ring-offset-gray-800">
                                                                    Edit
                                                                </Link>
                                                            }

                                                        </>
                                                    }

                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>

                            </div>

                            {(apiData?.meta?.from) !== undefined &&
                                <>
                                    <p className='float-left mt-7'>
                                        {`Showing ${apiData?.meta?.from * 1} - ${apiData?.meta?.to * 1} out of ${apiData?.meta?.total * 1}`}
                                    </p>


                                    {(apiData?.links?.next !== null && apiData?.links?.next !== "") &&
                                        <button onClick={() => pagination(1)} className="custom-btn float-right mt-5">
                                            Next Page&nbsp;&nbsp;&rarr;
                                        </button>
                                    }

                                    {(apiData?.links?.prev !== null && apiData?.links?.prev !== "") &&
                                        <button onClick={() => pagination(0)} className="custom-btn float-right mt-5 mr-2">
                                            &larr;&nbsp;&nbsp;Previous Page
                                        </button>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>



            {/* Popup */}
            {((deleteModal?.isShow === true) && deleteModal.id !== "") &&
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                            {/*content*/}
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <button type="button" onClick={() => setDeleteModal(false)} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" data-modal-toggle="popup-modal">
                                    <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                                <div className="p-6 text-center">
                                    <svg aria-hidden="true" className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                                        Are you sure to update availability status this offer?
                                    </h3>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => deleteOffer(deleteModal.id)} className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                                        Yes, I'm sure
                                    </button>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => setDeleteModal(false)} className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">No, cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            }

            {/* Model Window */}
            {(isTermsShow === true) &&
                <div>
                    <Popup content={
                        <form className="p-5 font-medium">
                            <div className="flex justify-between">
                                <h3 className="text-lg text-black font-semibold">Voucher Offer Information</h3>
                                <CloseBtn className="cursor-pointer" onClick={closeModel} />
                            </div>

                            <div className='max-w-lg mt-6 pr-1 whitespace-break-spaces'>
                                <div className='flex w-full items-center'>
                                    <img src={termsData?.logo} className="w-[120px]" alt='Brand Logo' />
                                    <div className='ml-5 border-l-2 border-l-slate-100 pl-3'>
                                        {(termsData?.sku) && 
                                            <div className="mb-3">
                                                <h3 className="text-md text-black font-semibold">SKU / Plan Code / Other Identity</h3>
                                                {termsData?.sku}
                                            </div>
                                        }

                                        <h3 className="text-lg text-black font-semibold">Terms and Conditions</h3>
                                        {termsData?.terms}

                                        <h3 className="text-lg text-black font-semibold mt-4">Created On</h3>
                                        {moment(termsData?.created_at).format("DD MMM, YYYY @ hh:mm A")}
                                    </div>
                                </div>
                            </div>

                        </form>}
                    />
                </div>
            }



        </div>
    );
};

export default Offer;